
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const ALLERGY_API_DATE_FORMATS = ["DD-MM-YYYY", "YYYY-MM-DD", "DD/MM/YYYY"];

export function parseAllergyApiDate(
  value: string | null | undefined,
): string | null {
  if (!value) return null;
  const parsed = dayjs(value, ALLERGY_API_DATE_FORMATS, true);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : null;
}

export function normalizeAllergyItem(item: AllergyListType): AllergyListType {
  return {
    ...item,
    identificationDate: parseAllergyApiDate(item.identificationDate),
    resolvedDate: parseAllergyApiDate(item.resolvedDate ?? null),
  };
}

export type AllergyContextType = {
  list: AllergyListType[];
  setList: (
    item: AllergyListType[] | ((params: AllergyListType[]) => AllergyListType[])
  ) => void;
  edit: AllergyListType | null;
  setEdit: (item: AllergyListType | null) => void;
  success:boolean,
  setSuccess: React.Dispatch<React.SetStateAction<boolean>>
};



export type AllergyListType = {
  id: number;
  allergen: {
    allergenId: number;
    allergenName: string;
  };
  allergyType: {
    allergyTypeId: number;
    allergyTypeName: string;
  };
  identificationDate: string | null;
  resolvedDate?: string | null;
  notes: string | null;
  reactions: string;
  description: string;
  lifeCycleStatus: {
    id: number;
    description: string;
  };
  severity: {
    allergySeverityId: number;
    allergySeverityName: string;
  };
}

export type AllergyDropdownType = {
  allergyTypeClinicId: number;
  allergyTypeName: string;
  allergyTypeCode: string;
  allergyTypeId: number;
};

export type AllergenType = {
  allergenId: number;
  allergenName: string;
};

export type AllergySeverityType = {
  allergySeverityClinicId: number;
  allergySeverityName: string;
  allergySeverityId: number;
  allergySeverityCode: string;
};

export type AllergyStatusType = {
  id: number;
  description: string;
  statusCode: string;
};

export type postAllergy = {
  id: number | null;
  typeId: number;
  allergenId: number | null;   
  description: string;
  reactions: string | null;    
  severityId: number | null;   
  identificationDate: string | null;
  resolvedDate: string | null;
  encounterId: number;
  clinicId: number;
  status: number;
  patientId: number;
  createdById: number;
  createdDate: string | null;
  hl7MsgStatus: number;
  actionCode: string | null;
  allergyStatus: number | null;
};



